import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Context/authContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!user) {
    return (
      <Navigate to={`/?redirect=${encodeURIComponent(location.pathname)}`} />
    );
  }

  return children;
};

export default ProtectedRoute;
